import TranscriptComponent from './component.jsx'
export default TranscriptComponent
